<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <p class="d-md-none" style="text-align: center;">
                    <img src="img/brand/logo-evai.png" width="70">
                    <img src="img/brand/logo-big.png" width="100" style="margin-top: -10px;margin-left: 20px;">
                  </p>
                  <h1>Login</h1>
                  <p v-if="loginView" class="text-muted">Inserisci le credenziali</p>
                  <p v-if="!loginView" class="text-muted">Inserisci username</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input v-model="username" type="text" class="form-control" placeholder="Username" autocomplete="username email" />
                    <span v-if="resetPasswordSuccess && !loginView" class="text-success">&nbsp;
                      Congratulazioni !! Ti abbiamo inviato una Email con le istruzioni per modificare la password
                    </span>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend v-if="loginView"><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input v-if="loginView" v-model="password" type="password" class="form-control" placeholder="Password" autocomplete="current-password" />
                    <b-form-invalid-feedback v-if="loginView" :force-show="error">
                      Username o password errati
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!loginView" :force-show="error">
                      Username non valido oppure token già inviato, attendere almeno 5 minuti per un nuovo
                      invio
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button :disabled="loading" v-if="loginView" variant="primary" class="px-4" @click="loginClick"><i v-if="loading" class="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Login</b-button>
                      <b-button :disabled="loading" v-if="!loginView" variant="primary" class="px-4" @click="resetPasswordClick"><i v-if="loading" class="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Reset password</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button v-if="loginView" variant="link" class="px-0" @click="changeToResetPasswordView">Forgot password?</b-button>
                      <b-button v-if="!loginView" variant="link" class="px-0" @click="changeToLoginView">Go to login</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="py-5 d-none d-md-block" >
              <b-card-body class="text-center">
                <div>
                  <img src="img/brand/logo-evai.png" width="150" style="margin-top: 30px;">
                  <img src="img/brand/logo-big.png" width="150" style="margin-top: 40px;">
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
      <p class="text-center pt-3"><a href="https://www.gtalarm.it" target="_blank">GT Alarm</a> Copyright © 2018 Tutti i diritti riservati.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      error: false,
      loading: false,
      loginView: true,
      resetPasswordSuccess: false
    }
  },
  methods: {
    loginClick: function() {
      this.loading = true;
      this.$store.dispatch('login', { username: this.username, password: this.password })
        .then(() => this.$router.push('/vehicles'))
        .catch((err) => {
          this.error = true;
          this.loading = false;
        });
    },
    changeToResetPasswordView: function() {
      this.loginView = false;
      this.error = false;
    },
    changeToLoginView: function() {
      this.loginView = true;
      this.error = false;
      this.resetPasswordSuccess = false
    },
    resetPasswordClick: function() {
      if(this.username){
        this.loading = true;
        this.error = false;
        this.resetPasswordSuccess = false;

        this.$store.dispatch('resetPassword', { username: this.username })
        .then(() => {
            this.loading = false;
            this.resetPasswordSuccess = true;
          })
        .catch((err) => {
          this.error = true;
          this.loading = false;
        });
      } else  {
        this.error = true;
      }
    }
  }
}
</script>
